<div class="search-no-result-container">
  <div class="content">
    <svg viewBox="0 0 200 45" class="slope">
      <path d="M 0,12 200,0 v 45 H 0 Z"></path>
    </svg>
    <div class="maincontainer">
      <kion-headline-tag [title]="'search.no-result.headline' | translate: {query: query}"></kion-headline-tag>
      <div class="wrap">
        <div class="text">
          <div class="description">
           {{ 'search.no-result.description' | translate }}
          </div>
        </div>
        <div class="imgcontainer">
          <img
            lazyLoad="./assets/images/curious.png"
            defaultImage="./assets/images/curious.png"
            errorImage="./assets/ui/shared/error/not_found_error_image.png"
            alt="no_result"
            title="no_result"
            src="#"
          />
        </div>
      </div>
    </div>
  </div>
</div>
